import { render, staticRenderFns } from "./roadmap.vue?vue&type=template&id=37736a12&scoped=true&"
import script from "./roadmap.vue?vue&type=script&lang=js&"
export * from "./roadmap.vue?vue&type=script&lang=js&"
import style0 from "./roadmap.vue?vue&type=style&index=0&id=37736a12&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37736a12",
  null
  
)

export default component.exports